<template>
  <vc-date-picker
    :value="value"
    @input="$emit('input', value)"
    @change="handleInput"
    v-on="$listeners"
    :min-date="minDate"
  >
    <template #default="{ inputValue, inputEvents }">
      <div
        class="p-input-component"
        :class="{ 'd-flex align-items-center': inline }"
      >
        <div
          v-if="label"
          class="d-flex align-items-center"
        >
          <div
            v-if="required"
            class="required-dot"
          />
          <label
            :for="id"
            class="form-label"
            v-bind="labelElProps"
          >
            {{ label }}
          </label>
        </div>
        <input
          :id="id"
          type="text"
          class="form-control"
          :value="inputValue"
          :disabled="disabled"
          v-bind="inputProps"
          required
          :placeholder="placeholder"
          :readonly="readonly"
          v-on="inputEvents"
          @blur="$emit('blur', value)"
          @change="handleInput"
          autocomplete="off"
        >
      </div>
    </template>
  </vc-date-picker>
</template>

<script>
import { commonInputProps } from '~/helpers/component-props/input-props'
import dayjs from 'dayjs'

export default {
  name: 'PvcDatepicker',
  props: commonInputProps,
  computed: {
    minDate () {
      return this.allowAllDates ? null : (this.miniDateProp ? dayjs(this.miniDateProp).toDate() : dayjs().toDate())
    }
  },
  methods: {
    handleInput (value) {
      this.$emit('change', value)
    }
  }
}
</script>

<style lang="scss" scoped>
.p-input-component {
    .form-control:disabled, .form-control[readonly] {
        background-color: #e9ecef !important;
        opacity: 1;
    }
}
</style>
